export enum PropertyHeatingTypeEnum {
  NONE = '0',
  CENTRAL = '1',
  INDIVIDUAL = '2',
}
